import React from 'react';
import { isChunkLoadError, reloadOnceForChunkError, clearReloadFlag } from '../utils/lazyLoad';
import './ChunkErrorBoundary.css';

/**
 * Catches render errors from the lazy routes. For chunk load errors it
 * auto-reloads once per session (stale tab after a deploy); if that guard
 * has already fired, it shows a manual reload prompt instead of looping.
 */
class ChunkErrorBoundary extends React.Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error) {
        reloadOnceForChunkError(error);
    }

    componentDidUpdate(prevProps) {
        // Clear the error when the route changes (e.g. browser back)
        if (this.state.error && prevProps.pathname !== this.props.pathname) {
            this.setState({ error: null });
        }
    }

    handleReload = () => {
        clearReloadFlag();
        window.location.reload();
    };

    render() {
        if (this.state.error) {
            const stale = isChunkLoadError(this.state.error);
            return (
                <div className="chunk-error-screen">
                    <h2>{stale ? 'A new version is available' : 'Something went wrong'}</h2>
                    <p>
                        {stale
                            ? 'The portal was updated. Reload the page to continue.'
                            : 'This page failed to load. Reloading usually fixes it.'}
                    </p>
                    <button className="chunk-error-reload" onClick={this.handleReload}>
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ChunkErrorBoundary;
